import React from 'react';
import styled from 'styled-components';

const Pattern = ({ src, alt }) => {
    const PatternImage = styled.img`
        display: block;
        width: 100%;
        height: 100%;
    `;
    return <PatternImage src={src} alt={alt || ''} />;
};
export default Pattern;



// WEBPACK FOOTER //
// ./src/components/pattern/Pattern.js